import React, { useEffect } from "react";
import { Select, Option, Spinner, Typography, Chip } from "@material-tailwind/react";
import { HomeIcon } from "@heroicons/react/24/outline";
import { colors } from "../utils/colors";

// Fonction pour obtenir les détails du statut
const getStatusDetails = (status) => {
  switch (status) {
    case 'appointment_confirmed':
      return { label: "RDV confirmé", color: "cyan" };
    case 'appointment_scheduled':
      return { label: "RDV programmé", color: "light-blue" };
    case 'invoice_pending':
      return { label: "Facture en attente", color: "amber" };
    case 'payment_required':
      return { label: "Paiement requis", color: "red" };
    case 'dpe_consent_required':
      return { label: "Accord DPE requis", color: "orange" };
    case 'documents_required':
      return { label: "Documents requis", color: "orange" };
    case 'report_in_preparation':
      return { label: "Rapport en préparation", color: "blue-gray" };
    case 'report_ready':
      return { label: "Rapport prêt", color: "green" };
    default:
      return { label: "Statut inconnu", color: "gray" };
  }
};

export default function PropertySelector({
  selectedProperty,
  setSelectedProperty,
  properties = [],
  isLoading,
  displayContext = 'diagnostics'
}) {
  useEffect(() => {
    if (!isLoading && Array.isArray(properties) && properties.length > 0 && !selectedProperty) {
      setSelectedProperty(String(properties[0].id));
    }
  }, [isLoading, properties, selectedProperty, setSelectedProperty]);

  if (isLoading) {
    return (
      <div className="p-4 flex items-center justify-center">
        <Spinner className="h-8 w-8" style={{ color: colors.dimoPrimary }} />
      </div>
    );
  }

  if (!Array.isArray(properties)) {
    return (
      <div className="p-4 text-red-500">
        <p>Erreur : Les dossiers ne sont pas disponibles.</p>
      </div>
    );
  }

  return (
    <div className="border-b border-gray-200">
      <Typography variant="h6" color="black" className="mb-1">
        Sélectionnez un dossier
      </Typography>
      <Select
        size="lg"
        className="propSelector"
        label=""
        value={selectedProperty ? String(selectedProperty) : ""}
        onChange={(value) => setSelectedProperty(value)}
        labelProps={{
          className: 'before:mr-0 after:ml-0',
        }}
      >
        {properties.map((property, index) => {
          let statusDetails;
          if (displayContext === 'actions') {
            const hasActions = Object.values(property.actionsNeeded || {}).some(needed => needed === true);
            statusDetails = hasActions 
              ? { label: "Action(s) requise(s)", color: "orange" }
              : { label: "Tout est en ordre", color: "green" };
          } else if (displayContext === 'documents') {
            statusDetails = property.actionsNeeded?.customerDocument
              ? { label: "Manquant", color: "orange" }
              : { label: "OK", color: "green" };
          } else {
            statusDetails = getStatusDetails(property.propertyStatus);
          }

          return (
            <Option key={`${property.id}-${index}`} value={String(property.id)}>
              <div className="flex items-center justify-between w-full propSelector-option">
                <div className="flex items-center gap-2 overflow-hidden">
                  <HomeIcon className="h-6 w-6 flex-shrink-0 hidden sm:block" style={{ color: colors.dimoPrimary }} />
                  <span className="text-base leading-tight truncate">{property.id} - {property.address || 'Adresse non définie'}</span>
                </div>
                <Chip 
                  variant="ghost"
                  size="sm"
                  value={statusDetails.label}
                  color={statusDetails.color}
                  className="ml-2 flex-shrink-0 text-xs px-1.5 py-0.5"
                />
              </div>
            </Option>
          );
        })}
      </Select>
    </div>
  );
}

